import { Truck, Package, Warehouse, Clock, Route, Boxes, ShieldCheck, Globe, Forklift, Container } from "lucide-react";

export const COMPANY = {
  name: "LINCESSO GROUP TRASPORTI",
  street: "Via Ludovico Ariosto, 1/B",
  cap: "74123",
  city: "Taranto",
  province: "TA",
  country: "Italia",
  supportEmail: "lincessogroup@gmail.com",
};

export const FULL_ADDRESS = `${COMPANY.street}, ${COMPANY.cap} ${COMPANY.city} (${COMPANY.province}), ${COMPANY.country}`;
export const MAP_QUERY = encodeURIComponent("Via Ludovico Ariosto 1B, 74123 Taranto TA, Italia");

export const SERVICE_ICONS = {
  truck: Truck, package: Package, warehouse: Warehouse, clock: Clock, route: Route,
  boxes: Boxes, shield: ShieldCheck, globe: Globe, forklift: Forklift, container: Container,
};
